/**
 * @description : Confirm Popup
 * @author : Vineela Rani
 * @date : 07-06-2023
 * */

/* Import Components and Functions Here */
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { TiTick } from 'react-icons/ti';
import { ImCross } from 'react-icons/im';
import styles from './popups.module.scss';

function ConfirmPopup(props) {
  const navigate = useNavigate();

  /* Onclick Event will call this and Navigate to Other Component*/
  const handleNavigate = () => {
    if (props.routeTo === 'closePopup') {
      props.close(true);
    } else {
      navigate(props.routeTo);
    }
  };

  return (
    <>
      <Modal
        size="sm"
        show={props.show}
        onHide={() => props.close && props.close(true)}
        centered
      >
        <Modal.Body
          className={
            'text-center ' +
            (props.status === 'success'
              ? styles.successPopup
              : styles.errorPopup)
          }
        >
          {props.status === 'success' ? (
            <TiTick className={styles.successIcon} />
          ) : (
            <ImCross className={styles.errorIcon} />
          )}
          <h5>{props.title}</h5>
        </Modal.Body>
        <Modal.Footer className="mt-1 d-flex justify-content-center">
          <Button
            style={{ minWidth: '75px' }}
            variant="primary"
            onClick={handleNavigate}
          >
            {props.buttonTxt}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmPopup;
